import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { info } from 'console';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-cashback-report',
  templateUrl: './cashback-report.component.html',
  styleUrls: ['./cashback-report.component.scss']
})
export class CashbackReportComponent implements OnInit {
  
  monthArray = [
    {id:1,name:'January'},
    {id:2,name:'February'},
    {id:3,name:'March'},
    {id:4,name:'April'},
    {id:5,name:'May'},
    {id:6,name:'June'},
    {id:7,name:'July'},
    {id:8,name:'August'},
    {id:9,name:'September'},
    {id:10,name:'October'},
    {id:11,name:'November'},
    {id:12,name:'December'}
  ];
    
  Year = [2023,2022,2021]

  filteredDetails:any = {
    name: '',
    month: '',
    year: ''
  }
  page:any = 1
  sendDetailsToChild:any = ''
  ComponentNo = 1
  CashbackReawardList:any[] = []
  getPaginationCount:any

  constructor(
    private modalService : NgbModal,
    private route : Router,
    private apiService : ApiService,
    private apiConfig : ApiConfiguration 
    ) { }

  ngOnInit() {
    this.getCashBackList()
  }

  filterListOfRecords(){
    this.getCashBackList()
  }

  Reset(){
    this.filteredDetails.name = '',
    this.filteredDetails.month= '',
    this.filteredDetails.year= ''
    this.getCashBackList()
  }
  paginationClick(event){
    this.page = event
    this.getCashBackList()
  }
  createNewCashback(data){
    this.route.navigateByUrl("/hubAdmin/cashback-steps/" + data )
  }
  EditCashBack(data){
    this.route.navigateByUrl("/hubAdmin/cashback-steps/" + data )
  }
  getCashBackList(){
    this.apiService.getHeaders(this.apiConfig.getCashBackList + `?program_id=1&page=${this.page}&name=${this.filteredDetails.name}&month=${this.filteredDetails.month}&year=${this.filteredDetails.year}`).subscribe((res:any)=>{
      console.log(res)
      this.CashbackReawardList = res.body.data
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
      
    })
  }
}
